if (!customElements.get('product-model')) {
  customElements.define('product-model', class ProductModel extends DeferredMedia {
    constructor() {
      super();
    }

    loadContent() {
      super.loadContent();

      Shopify.loadFeatures([
        {
          name: 'model-viewer-ui',
          version: '1.0',
          onLoad: this.setupModelViewerUI.bind(this),
        },
      ]);
    }

    setupModelViewerUI(errors) {
      if (errors) return;

      this.modelViewerUI = new Shopify.ModelViewerUI(this.querySelector('model-viewer'));
      this.querySelector('model-viewer').addEventListener('load', (event) => {
        this.classList.add('loaded-3d');
      })
    }
  });
}

window.ProductModel = {

  didLoad: false,
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    console.log("INITIALIZED SHOPIFY XR");
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () =>
        this.setupShopifyXR()
      );
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

Array.from(document.querySelectorAll('.model-popup-open-btn')).forEach(btn=>{
  btn.addEventListener("click",()=>{
    if(!window.ProductModel.didLoad){
      window.ProductModel.didLoad = true;
      window.ProductModel.loadShopifyXR();
    }
  })
})

// window.addEventListener('DOMContentLoaded', () => {
//   if (window.ProductModel) window.ProductModel.loadShopifyXR();
// });
